export default __webpack_public_path__ + "static/media/remove.ece17dd5.svg";